<template>
  <EmptySubscriptionPage
    v-if="!hasFeatureFlag('module-products')"
    :text="{
      title: $t('upgrade_subscription_page.products.stock_orders.title'),
      description: $t(
        'upgrade_subscription_page.products.stock_orders.description'
      ),
      btnPrimary: $t('upgrade_subscription_page.upgrade_btn')
    }"
    :moreLink="{
      text: $t('upgrade_subscription_page.products.stock_orders.learn_more'),
      url: helpCenterCollectionUrl($t('upgrade_subscription_page.products.stock_orders.learn_more_url'))
    }"
    imageName="products"
  />
  <Flex
    direction="column"
    v-else
  >
    <Page
      :query="GET_STOCK_ORDERS"
      :multiLocation="true"
      :actions="{
        text: 'global.actions.new_stock_order',
        route: 'products-order-new',
      }"
      :emptyPageContent="{
        route: 'products-order-new',
        title: $t('products.empty_state.stock_orders.title'),
        description: $t('products.empty_state.stock_orders.description'),
        btnPrimary: $t('global.actions.create_stock_order'),
        imageName: 'products',
      }"
      :dropdownItems="dropdownItems"
      :queryVariables="{
        status: '',
      }"
    >
      <StockOrdersList />
    </Page>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { helpCenterCollectionUrl } from '@/helpers/help-center';
import EmptySubscriptionPage from '@/modules/_shared/subscription/EmptySubscriptionPage.vue';
import { useUserStore } from '@/stores/user';
import Page from '../_shared/Page.vue';
import { GET_STOCK_ORDERS } from './graphql';
import StockOrdersList from './StockOrdersList.vue';

const { hasFeatureFlag } = useUserStore();

import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const dropdownItems = [
  {
    value: '',
    label: t('global.all'),
  },
  {
    value: 'open',
    label: t('global.open'),
  },
  {
    value: 'ordered',
    label: t('global.ordered'),
  },
  {
    value: 'complete',
    label: t('global.completed'),
  },
  {
    value: 'paid',
    label: t('global.paid'),
  },
  {
    value: 'backorder',
    label: t('global.backorder'),
  },
];
</script>
